<template>
    <div v-if="loading" class="flex min-h-[70vh] items-center justify-center"><Loader /></div>
    <div v-else class="ds-employees-page-tabs">
        <div class="pt-3 flex flex-col flex-1 min-h-0">
            <Tabs :tabs tab-font-size="16" px="65" tab-margin-right="22" borderBottomWidth="2">
                <template v-slot:tab1>
                    <EmployeesList :archive="false" @user-click="onUserClick" @create="openUserCreatePanel" />
                </template>
                <template v-slot:tab2>
                    <EmployeesList :archive="true" @user-click="onUserClick" />
                </template>
            </Tabs>
        </div>
        <SidePanel ref="usercard">
            <EmployeesInfo @fired="onUserCreated" :archive="isArchive" @user-edit="init()" />
        </SidePanel>

        <SidePanel ref="usercreate">
            <CreateUser @close="openUserCreatePanel" @created="onUserCreated"/>
        </SidePanel>
    </div>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue'
import Tabs from '@/components/Tabs.vue'
import { Tab } from '@/types'
import EmployeesList from '@/components/employees/EmployeesList.vue'
import SidePanel from '@/components/schedule/SidePanel.vue'
import EmployeesInfo from '@/components/employees/EmployeesInfo.vue'
import Loader from '@/ui/Loader.vue'
import CreateUser from '@/components/employees/CreateUser.vue'
import { useDepartmentStore } from '@/stores/departmentStore'
import { useEmploymentStore } from '@/stores/employmentStore'
import { useAuthStore } from '@/stores/authStore'
import { useToast } from 'vue-toast-notification'

const toast = useToast({ position: 'top' })

const departmentStore = useDepartmentStore()
const employmentStore = useEmploymentStore()
const authStore = useAuthStore()

const loading = ref(true)
const isArchive = ref(false)

const tabs: Tab[] = [
    { name: 'tab1', label: 'Активные сотрудники' },
    { name: 'tab2', label: 'Архив' , disabled: !authStore.permissions?.can_view_user_archive}
]

const usercard = ref()
const usercreate = ref()

const openUserPanel = () => {
    usercard.value.toggle()
}

const openUserCreatePanel = () => {
     if(authStore.permissions?.can_create_user) {
        usercreate.value.toggle()
    } else {
        toast.error('У вас нет прав на данное действие')
    }
}

const onUserClick = async (data:any) => {
    openUserPanel()
    employmentStore.user = employmentStore.users.find(user => user.id === data.id)
    isArchive.value = data.archive
}

const onUserCreated = () => {
    openUserCreatePanel()
}

const init = async () => {
    loading.value = true
    await departmentStore.fetchMyDepartments()
    loading.value = false
}

onMounted(() => {
    init()
})
</script>
